// extracted by mini-css-extract-plugin
module.exports = {"container":"bHPjYGcpCirMCSz+oMl3Ow==","centerAlign":"_6ZNeh1Sf6A+PMMXSNSyWeg==","capitalize":"ZQhzWsfsVUWGuREGrGvcCQ==","bold":"iubLxIh-O3gxlEQlnzK8xw=="};